
import React from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function TeamListAssignedDefaultMessage() 
{
    const { team } = useCTAL();
  
    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <small>
                    <p><b>{team.TeamName} doesn't have any <u>Assigned</u> Actions yet!</b></p>

                    <p>Your Team's Assigned Actions list will be shown here to display "who is actively doing what" to achieve 
                       the Goal shown above. By selecting an Action from this list you will be able to see a detailed Action view to monitor progress.</p>

                    <div class="row mt-0">
                        <div class="col-1 mt-1">
                            <a href="#"><img class="card-icon" src="./images/checklist.svg" alt="add" border="0"/></a>
                        </div>
                        <div class="col">
                            Click on the Team Actions icon above to view unassigned Team Actions and either use an Action's drop-down
                            menu or detail view to Assign the Action to a team member.
                        </div>
                    </div>
          
                    <p class="mt-3">Let's get going!</p>
                </small>
            </div>
        </> 
    );
}